import { BffDashboard } from "vmd-types";

import { STRAPI_URL } from "../env";
import {
  appQueryClient,
  fetchWithCache,
  invalidateAppQueries,
} from "./query-cache";

export async function fetchDashboard(): Promise<BffDashboard | undefined> {
  return fetchWithCache({
    queryKey: ["dashboard"],
    staleTime: 15 * 60 * 1000,
    fallback: appQueryClient.getQueryData<BffDashboard>(["dashboard"]),
    queryFn: async () => {
      const response = await fetch(`${STRAPI_URL}/bff-dashboard`, {
        credentials: "include",
      });

      if (response.status >= 400) {
        throw new Error(`Fetch failed with status ${response.status}.`);
      }

      return (await response.json()) as BffDashboard;
    },
  });
}

export async function updateManagementSummary(
  managementSummary: string
): Promise<void> {
  const response = await fetch(
    `${STRAPI_URL}/bff-dashboard/management-summary`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ managementSummary }),
    }
  );

  if (response.status >= 400) {
    throw new Error(`Fetch failed with status ${response.status}.`);
  }
  await invalidateAppQueries(["dashboard"]);
}
